/**
 * Summary Alert
 */
import { ReactNode } from 'react';
import clsx from 'clsx';

import IconDanger from 'src/assets/images/icons/danger.svg';
import IconTick from 'src/assets/images/icons/tick-circle.svg';

interface IAlertProps {
  isApprove?: boolean;
  title: string;
  info: ReactNode;
}

export const SummaryAlert: React.FC<IAlertProps> = (props) => {
  const { isApprove, title, info } = props;

  return (
    <div className={clsx('px-12 py-14 xl:py-20 rounded-12 flex items-center gap-16', isApprove ? 'bg-green-10' : 'bg-red-10')}>
      <div className='w-40 xl:w-48'>
        {isApprove ? <img src={IconTick} alt='' className='w-40 xl:w-48' /> : <img src={IconDanger} alt='' className='w-40 xl:w-48' />}
      </div>
      <div className='flex-1'>
        <h3 className='text-14 xl:text-16 font-bold mb-4'>{title}</h3>
        <p className='text-10 xl:text-12 text-blue_grey-80'>{info}</p>
      </div>
    </div>
  );
};
